import { render, staticRenderFns } from "./RecurrenceInterventionsSecondairesEdit.vue?vue&type=template&id=528c9b69"
import script from "./RecurrenceInterventionsSecondairesEdit.vue?vue&type=script&lang=ts"
export * from "./RecurrenceInterventionsSecondairesEdit.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports